import axios from 'src/utils/axios';
import { endpoints } from 'src/utils/api-endpoints';
import { Evaluation } from 'src/models/evaluation';
import { AppResponse } from 'src/models/app-response';

export async function evaluateSubTopic(
  user: string,
  skill: string,
  topicId: string,
  isCompleted: boolean,
  subItemId?: string | null
): Promise<AppResponse<{ isCompleted: boolean; evaluation: Evaluation } | null>> {
  try {
    const response = await axios.post(endpoints.evaluation.update, {
      user,
      skill,
      topicId,
      subItemId: subItemId ?? null,
      isCompleted,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update evaluation status:', error);
    return { success: false, data: null, error };
  }
}

export async function getMyEvaluations(): Promise<AppResponse<Evaluation[]>> {
  try {
    const response = await axios.get(endpoints.evaluation.getMyEvaluations);
    return response.data;
  } catch (error) {
    console.error('Failed to get my evaluations:', error);
    return { success: false, data: [], error };
  }
}

export async function getUserEvaluations(userId: string): Promise<AppResponse<Evaluation[]>> {
  try {
    const response = await axios.get(endpoints.evaluation.getUserEvaluations(userId));
    return response.data;
  } catch (error) {
    console.error(`Failed to get evaluations for user ${userId}:`, error);
    return { success: false, data: [], error };
  }
}

export async function resetEvaluation(skillId: string): Promise<AppResponse<{ reset: boolean; skillId: string } | null>> {
  try {
    const response = await axios.delete(endpoints.evaluation.reset(skillId));
    return response.data;
  } catch (error) {
    console.error(`Failed to reset evaluation for skill ${skillId}:`, error);
    return { success: false, data: null, error };
  }
}